const TestIssueReason = Object.freeze({
    GD: 0,
    CF: 1,
    TYPE1: 2,
    RESEARCH_STUDY: 3,
    TYPE2: 4
})

export default TestIssueReason